<template>
  <v-row>
    <v-col cols="12" md="12">
      <v-card :elevation="1">
        <v-card-item>
          <v-card-title class="text-left">security categories</v-card-title>
          <v-card-subtitle class="text-left"></v-card-subtitle>
          <template v-slot:append>
            <v-btn icon="mdi-cog-outline" variant="text" @click="this.$router.push('/securitycategories/config')"></v-btn>
            <v-btn icon="mdi-plus" variant="text" @click="showNewCategoryModal = true"></v-btn>
          </template>
        </v-card-item>
        <v-divider></v-divider>
          <v-card-text>
            <v-table density="compact">
              <thead>
                <tr>
                  <th>id</th>
                  <th>ticker</th>
                  <th>broad</th>
                  <th>type</th>
                  <th>country</th>
                  <th>tags</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="category in categories" :key="category.id">
                  <td class="text-left" @click="showCategoryEditModal(category)">{{ category.id }}</td>
                  <td class="text-left" @click="showCategoryEditModal(category)">{{ category.ticker }}</td>
                  <td class="text-left" @click="showCategoryEditModal(category)">{{ category.broad.name }}</td>
                  <td class="text-left" @click="showCategoryEditModal(category)">{{ category.type.name }}</td>
                  <td class="text-left" @click="showCategoryEditModal(category)">{{ category.country.name }}</td>
                  <td class="text-left">
                    <v-chip v-for="tag in findLeafTags(category.tags)" :key="tag.id" size="small" class="ma-2">{{ tag.path }}</v-chip>
                    <v-btn icon="mdi-plus" variant="text" @click="showTheAddTagToCatgeoryModal(category)" v-tooltip="'add tag'"></v-btn>
                    <v-btn v-if="category.tags.length > 0" icon="mdi-close" variant="text" @click="removeTagsFromCategory(category)" v-tooltip="'remove tags'"></v-btn>
                  </td>
                </tr>
              </tbody>
            </v-table>
          </v-card-text>
      </v-card>
    </v-col>
  </v-row>
  
  <v-row v-if="UncatSecurities">
    <v-col cols="12" md="12">
      <v-card :elevation="1">
        <v-card-item>
          <v-card-title class="text-left">uncategorised open securities</v-card-title>
          <v-card-subtitle class="text-left"></v-card-subtitle>
          <template v-slot:append>
          </template>
        </v-card-item>
        <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <v-table density="compact">
                <thead>
                  <tr>
                    <th>ticker</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="security in uncategorised_securities" :key="security.ticker">
                    <td class="text-left">{{ security.ticker }}</td>
                  </tr>
                </tbody>
              </v-table>
            </v-container>
          </v-card-text>
      </v-card>
    </v-col>
  </v-row>
  
  <v-snackbar v-if="uncategorised_securities.length > 0" v-model="snackbar" top :timeout="-1">
    You have {{ uncategorised_securities.length }} uncategorised open securities
    <template v-slot:actions>
      <v-btn color="pink" variant="text" @click="showUncatSecurities()">
        show
      </v-btn>
    </template>
  </v-snackbar>
  
  <!-- txn modals -->
  <CategoryNewModal :show="showNewCategoryModal" @close="showNewCategoryModal = false"></CategoryNewModal> <!-- add new record -->
  <CategoryEditModal :show="showEditCategoryModal" :currentRow="selectedRow" @close="showEditCategoryModal = false"></CategoryEditModal> <!-- edit a record -->
  <CategoryAddTagModal :show="showAddTagModal" :currentRow="selectedRow" @close="showAddTagModal = false"></CategoryAddTagModal>
  
</template>

<script>
import axios from 'axios';
import { mapState, mapMutations} from 'vuex';
import CategoryNewModal from './modals/CategoryNewModalPopup.vue';
import CategoryEditModal from './modals/CategoryEditModalPopup.vue';
import CategoryAddTagModal from './modals/CategoryAddTagModalPopup.vue';

export default {
  components: {
    CategoryNewModal,
    CategoryEditModal,
    CategoryAddTagModal

  },
  data() {
    return {
      categories: [],
      open_positions: [],
      tags: [],
      mapTagsPaths: new Map(),
      uncategorised_securities: [],
      showNewCategoryModal: false,
      showEditCategoryModal: false,
      showAddTagModal: false,
      selectedRow: {},
      snackbar: Boolean,
      UncatSecurities: false
      
    };
  },
  async created() {
    await this.getCategories();
    await this.getOpenPositions();
    await this.getTags();
    this.findUncategorisedSecurities();
  },
  computed: {
    ...mapState({
      token: "token"
    })
  },
  methods: {
      ...mapMutations(["showSnackbar"]),
    async getCategories(){
      try {
      const response  = await axios.get("/securities/categorisations/",
      {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      });
        this.categories = response.data;
        
      
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load security categorisations' });
      }
    },
    async getOpenPositions(){
      try {
      const response  = await axios.get("/securities/portfolios/openpositions/",
      {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      });
        this.open_positions = response.data;
        
      
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load open positions' });
      }
    },
    async getTags(){
      try {
      const response  = await axios.get("/securities/categorisations/config/tags",
      {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      });
        this.tags = response.data;
        this.tags.forEach(tagObj => this.mapTagsPaths.set(tagObj.id, tagObj.path));
        
      
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load tags' });
      }
    },
    findUncategorisedSecurities(){
      this.uncategorised_securities = this.open_positions.filter(obj1 => !this.categories.some(obj2 => obj2["ticker"] === obj1["ticker"]));

      if(this.uncategorised_securities > 0){
        this.snackbar = true;
      }
    },
    async updatePageData(){
      await this.getCategories();
      await this.getOpenPositions();
      this.findUncategorisedSecurities();
    },
    async removeTagsFromCategory(category){
      try {
        const { data } = await axios.request({
          url: "/securities/categorisations/" + category.id + "/removetags",
          method: "PUT",
          headers: {
              Authorization: `Bearer ${this.token}`
          },
          data: {

          }
        });
          this.updatePageData();
          
      } catch (error) {
        this.showSnackbar({ message: 'Failed to update security categorisation tags' });
      }
    },
    showCategoryEditModal(row){
     this.selectedRow=row;
     this.showEditCategoryModal = true;
    },
    showTheAddTagToCatgeoryModal(row){
      this.selectedRow=row;
      this.showAddTagModal = true;
    },
    showUncatSecurities(){
      this.snackbar = false;
      this.UncatSecurities = true;

    },
    findLeafTags(tags) {
      // Create a Set of all parent_id values in the tags array
      const parentIds = new Set(tags.map(tag => tag.parent_tag_id).filter(id => id !== null && id !== undefined));

      // Filter tags that do not appear in the parentIds Set (i.e., they have no children)
      // Replace name with path from pathMap
      return tags
        .filter(tag => !parentIds.has(tag.id))
        .map(tag => ({
          id: tag.id,
          name: tag.name,
          path: this.mapTagsPaths.get(tag.id) || null, // Use null if no path found
          parent_tag_id: tag.parent_tag_id
        }));
    }
  }
};

</script>


<style scoped>
.text-h4 {
  font-family: 'Courier New', Courier, monospace, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

table{
  width: 100%;
}

table tr{
  cursor: pointer;
}

.fade-in-enter-active {
  transition: opacity 300ms cubic-bezier(0.55, 0.085, 0.68, 0.53);
}

.fade-in-leave-active {
  transition: opacity 225ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.fade-in-enter,
.fade-in-leave-to {
  opacity: 0;
}

.green_text{
  color: green;
}

.red_text{
  color: red;
}


</style>